var _path, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFast = function SvgFast(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H13V18H15C16.1046 18 17 18.8954 17 20Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 18,
    r: 2,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08663 15.8898C5.45448 13.0452 6.9145 10.1491 9.57738 8.96561L14 7L16 8C16.4846 9.33277 16.727 9.99915 16.848 10.6566C17.175 12.433 16.8912 14.2678 16.0428 15.8624C15.7288 16.4526 15.2964 17.0147 14.4318 18.1387L13 20H11.2104C8.75033 20 6.6203 18.2913 6.08663 15.8898Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5C21.5 8 17.6569 10 16 10C14.3432 10 13 8.65685 13 7C13 5.34315 7.34317 4 15 4C17.4 4 18.5 5 20 6.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38013 2.5L16.2189 4.09782L15.6198 7.03737L10.7205 6.03874C9.09703 5.70782 8.04921 4.12347 8.38013 2.5Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fast.4c021f8a400d4009ea67bc18f5e49686.svg";